module.exports = __webpack_public_path__ + "static/media/visiongis_logo.abbb5b66.png";